import type { Software } from '@/types/software';

export const softwareList: Software[] = [
  {
    id: 'xingguang',
    name: '星光影音',
    enName: 'Starlight Player',
    categoryId: 'windows-player',
    platforms: ['Windows'],
    type: '播放器',
    version: 'v8.6.2',
    size: '48.6 MB',
    developer: '星光科技',
    releaseDate: '2019-05-12',
    updateDate: '2026-09-28',
    downloads: 8620000,
    rating: 4.8,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20software%20cover%20art%20for%20a%20premium%20movie%20player%20application%2C%20dark%20navy%20gradient%20background%20with%20glowing%20amber%20light%20streaks%20and%20a%20stylized%20film%20reel%20icon%2C%20cinematic%20tech%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=cover-xingguang&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Dark%20themed%20video%20player%20software%20interface%20on%20a%20widescreen%20monitor%20showing%20a%20movie%20poster%20wall%20grid%2C%20sidebar%20navigation%2C%20modern%20clean%20UI%20design%2C%20deep%20blue%20and%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-xingguang-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Full%20screen%20movie%20playback%20view%20of%20a%20desktop%20media%20player%2C%20floating%20playback%20control%20bar%2C%20timeline%20scrubber%2C%20subtitle%20line%2C%20cinematic%20dark%20interface%20with%20amber%20highlights%2C%20no%20text&width=1280&height=720&seq=shot-xingguang-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Settings%20and%20subtitle%20configuration%20panel%20of%20a%20modern%20video%20player%20application%2C%20toggles%20and%20sliders%2C%20dark%20sleek%20interface%2C%20deep%20blue%20background%20with%20amber%20accent%20buttons%2C%20no%20text&width=1280&height=720&seq=shot-xingguang-3&orientation=landscape',
    ],
    summary: '老牌 Windows 高清播放器，本地 4K 片源与在线影视通吃，硬解效率高、启动快。',
    description: '星光影音是一款面向 Windows 平台的老牌高清影视播放器，凭借出色的硬件加速解码能力和极快的启动速度，成为众多影音爱好者的装机必备。软件内置完整的解码内核，无需额外安装解码包即可播放几乎所有主流格式，同时支持本地媒体库管理与在线影视源导入，兼顾画质与流畅度。',
    features: [
      { title: '全格式硬解', desc: '内置完整解码内核，支持 H.265/AV1 等新一代编码，播放 4K 片源 CPU 占用更低。' },
      { title: '智能媒体库', desc: '自动刮削本地影视文件信息，生成海报墙与剧集分季，管理海量片源井井有条。' },
      { title: '音画同步引擎', desc: '毫秒级音画同步算法，长时间播放不掉帧、不失步，影院级观看体验。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/starlight-8.6.2-setup.exe',
  },
  {
    id: 'jiguang',
    name: '极光播放器',
    enName: 'Aurora Player',
    categoryId: 'windows-player',
    platforms: ['Windows'],
    type: '播放器',
    version: 'v6.4.0',
    size: '39.2 MB',
    developer: '极光软件',
    releaseDate: '2018-11-03',
    updateDate: '2026-09-15',
    downloads: 6410000,
    rating: 4.6,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20software%20cover%20art%20for%20a%20sleek%20desktop%20video%20player%20app%2C%20deep%20blue%20to%20teal%20gradient%20background%20with%20aurora%20light%20ribbons%20and%20a%20minimal%20play%20button%20symbol%2C%20premium%20tech%20aesthetic%2C%20clean%20layout&width=800&height=500&seq=cover-jiguang&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Minimal%20desktop%20video%20player%20interface%20with%20a%20large%20movie%20thumbnail%20carousel%20at%20the%20top%2C%20recent%20files%20list%20below%2C%20dark%20clean%20UI%2C%20subtle%20blue%20glow%2C%20no%20text&width=1280&height=720&seq=shot-jiguang-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Video%20playback%20screen%20of%20a%20sleek%20media%20player%20with%20glassmorphism%20control%20overlay%2C%20volume%20slider%20and%20playback%20speed%20menu%2C%20dark%20cinematic%20look%2C%20no%20text&width=1280&height=720&seq=shot-jiguang-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Audio%20equalizer%20and%20output%20device%20selection%20panel%20inside%20a%20modern%20desktop%20video%20player%2C%20dark%20interface%20with%20teal%20and%20amber%20accent%20bars%2C%20no%20text&width=1280&height=720&seq=shot-jiguang-3&orientation=landscape',
    ],
    summary: '以简洁界面著称的桌面播放器，专注流畅播放与沉浸式观影，资源占用低。',
    description: '极光播放器主打轻量与简洁，安装包体积小、内存占用低，即使在配置一般的电脑上也能流畅播放高清片源。软件提供沉浸式无边框播放模式与丰富的快捷键操作，同时内置网络协议支持，可直接播放常见的在线点播地址。',
    features: [
      { title: '轻量低占用', desc: '安装包不足 40MB，后台内存占用低，老旧设备同样流畅运行。' },
      { title: '沉浸式观影', desc: '一键进入无边框全屏模式，隐藏多余控件，让注意力回归画面本身。' },
      { title: '网络流播放', desc: '支持主流流媒体协议，粘贴点播地址即可直接播放，无需下载到本地。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/aurora-6.4.0-setup.exe',
  },
  {
    id: 'lanjing',
    name: '蓝鲸影音',
    enName: 'BlueWhale Cinema',
    categoryId: 'windows-player',
    platforms: ['Windows'],
    type: '辅助工具',
    version: 'v3.9.1',
    size: '52.4 MB',
    developer: '蓝鲸工作室',
    releaseDate: '2020-03-21',
    updateDate: '2026-08-30',
    downloads: 3280000,
    rating: 4.5,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20software%20cover%20art%20for%20a%20media%20manager%20tool%2C%20deep%20ocean%20blue%20gradient%20background%20with%20a%20stylized%20whale%20silhouette%20and%20floating%20movie%20posters%2C%20premium%20clean%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-lanjing&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Media%20library%20management%20dashboard%20interface%20with%20colorful%20movie%20posters%20in%20a%20grid%2C%20filter%20sidebar%2C%20dark%20blue%20modern%20UI%20design%2C%20no%20text&width=1280&height=720&seq=shot-lanjing-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Batch%20file%20rename%20and%20metadata%20editing%20panel%20of%20a%20media%20tool%20on%20desktop%2C%20table%20rows%20and%20progress%20bars%2C%20dark%20sleek%20interface%20with%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-lanjing-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Subtitle%20download%20and%20sync%20assistant%20window%20in%20a%20desktop%20media%20application%2C%20dark%20UI%20with%20timeline%20and%20language%20list%2C%20blue%20glow%2C%20no%20text&width=1280&height=720&seq=shot-lanjing-3&orientation=landscape',
    ],
    summary: '配合本地播放器使用的媒体管理助手，自动整理海报墙、批量重命名与字幕匹配。',
    description: '蓝鲸影音是一款专注于本地影视资源管理的辅助工具，可以作为各类播放器的补充。它能自动扫描指定目录、刮削影片信息并生成精美的海报墙，还支持批量重命名、重复文件检测与多语言字幕自动匹配，让庞大的本地片库变得清爽有序。',
    features: [
      { title: '自动刮削', desc: '扫描本地目录自动匹配影片信息，一键生成海报墙与简介卡片。' },
      { title: '批量整理', desc: '支持按规则批量重命名、移动与去重，海量片库整理效率倍增。' },
      { title: '字幕匹配', desc: '按影片名与哈希自动检索多语言字幕，自动加载并校正时间轴。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/bluewhale-3.9.1-setup.exe',
  },
  {
    id: 'leiting',
    name: '雷霆播放器',
    enName: 'Thunder Play',
    categoryId: 'android-player',
    platforms: ['Android'],
    type: '播放器',
    version: 'v5.2.7',
    size: '28.9 MB',
    developer: '雷霆科技',
    releaseDate: '2020-06-18',
    updateDate: '2026-09-22',
    downloads: 7450000,
    rating: 4.7,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20app%20cover%20art%20for%20a%20mobile%20video%20player%2C%20dark%20navy%20background%20with%20a%20lightning%20bolt%20emblem%20and%20warm%20amber%20light%20bursts%2C%20premium%20tech%20aesthetic%2C%20clean%20composition&width=800&height=500&seq=cover-leiting&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20a%20mobile%20video%20player%20home%20page%20with%20a%20video%20thumbnail%20list%20and%20bottom%20tab%20bar%2C%20dark%20modern%20UI%2C%20blue%20and%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-leiting-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mobile%20video%20playback%20interface%20in%20landscape%20orientation%20with%20gesture%20volume%20and%20brightness%20indicators%2C%20dark%20cinematic%20UI%2C%20no%20text&width=1280&height=720&seq=shot-leiting-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mobile%20player%20settings%20screen%20with%20hardware%20decoding%20toggle%20and%20playback%20speed%20options%2C%20dark%20sleek%20interface%2C%20amber%20highlights%2C%20no%20text&width=1280&height=720&seq=shot-leiting-3&orientation=landscape',
    ],
    summary: '安卓端热门播放器，手势操作顺滑，支持投屏、倍速与悬浮小窗播放。',
    description: '雷霆播放器是 Android 平台上广受好评的视频播放工具，支持主流视频格式的硬件解码，配合顺滑的手势操作，让手机观影更加得心应手。软件提供倍速播放、悬浮小窗、投屏到大屏等实用功能，并内置私密文件夹保护个人片源。',
    features: [
      { title: '顺滑手势', desc: '左侧上下滑动调节亮度、右侧调节音量，横滑快进，单手即可完成操作。' },
      { title: '投屏与悬浮', desc: '一键投屏到电视或投影，悬浮小窗支持边看边聊，多任务两不误。' },
      { title: '私密保护', desc: '支持加密私密文件夹，指纹解锁访问，个人片源安全无忧。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/thunder-5.2.7.apk',
  },
  {
    id: 'weifeng',
    name: '微风影视',
    enName: 'Breeze TV',
    categoryId: 'android-player',
    platforms: ['Android'],
    type: '播放器',
    version: 'v4.8.3',
    size: '31.5 MB',
    developer: '微风网络',
    releaseDate: '2021-01-09',
    updateDate: '2026-09-05',
    downloads: 5120000,
    rating: 4.4,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20app%20cover%20art%20for%20a%20mobile%20streaming%20player%2C%20fresh%20deep%20blue%20gradient%20with%20flowing%20breeze%20curves%20and%20floating%20play%20icons%2C%20clean%20premium%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-weifeng&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Smartphone%20app%20interface%20for%20a%20streaming%20video%20service%2C%20featured%20banner%20with%20movie%20cards%20below%2C%20dark%20elegant%20UI%2C%20blue%20tones%20with%20amber%20buttons%2C%20no%20text&width=1280&height=720&seq=shot-weifeng-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mobile%20video%20player%20with%20episode%20list%20drawer%20open%20over%20playback%2C%20dark%20interface%2C%20progress%20bars%20and%20thumbnails%2C%20no%20text&width=1280&height=720&seq=shot-weifeng-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mobile%20app%20download%20and%20cache%20management%20screen%20with%20progress%20circles%20and%20file%20sizes%2C%20dark%20sleek%20UI%20design%2C%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-weifeng-3&orientation=landscape',
    ],
    summary: '集播放与在线观影于一体的安卓应用，剧集连播与离线缓存体验出色。',
    description: '微风影视是一款集本地播放与在线观影于一体的 Android 应用，界面清爽、剧集管理智能。软件支持多清晰度切换与离线缓存，通勤路上也能安心追剧；同时提供剧集自动连播与观看进度记忆，换设备也不丢进度。',
    features: [
      { title: '剧集连播', desc: '自动识别剧集并顺序播放，跳过片头片尾，追剧不间断。' },
      { title: '离线缓存', desc: '支持多清晰度下载缓存，无网络环境照样畅快观影。' },
      { title: '进度同步', desc: '自动记忆播放位置，多设备之间观看进度无缝衔接。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/breeze-4.8.3.apk',
  },
  {
    id: 'guangying',
    name: '光影盒子',
    enName: 'LightBox',
    categoryId: 'android-player',
    platforms: ['Android'],
    type: '辅助工具',
    version: 'v2.6.4',
    size: '22.3 MB',
    developer: '光影实验室',
    releaseDate: '2021-07-27',
    updateDate: '2026-08-19',
    downloads: 2360000,
    rating: 4.3,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20app%20cover%20art%20for%20a%20mobile%20media%20tool%2C%20deep%20blue%20background%20with%20a%20glowing%20translucent%20cube%20emitting%20amber%20light%20beams%2C%20clean%20premium%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-guangying&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Mobile%20video%20enhancement%20tool%20interface%20with%20brightness%20contrast%20and%20sharpness%20sliders%2C%20dark%20modern%20UI%20with%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-guangying-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mobile%20audio%20boost%20and%20equalizer%20screen%20with%20frequency%20bars%20and%20preset%20buttons%2C%20dark%20sleek%20interface%2C%20blue%20glow%2C%20no%20text&width=1280&height=720&seq=shot-guangying-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mobile%20subtitle%20editing%20tool%20with%20timeline%20tracks%20and%20text%20blocks%20over%20a%20dark%20video%20preview%2C%20clean%20UI%20design%2C%20no%20text&width=1280&height=720&seq=shot-guangying-3&orientation=landscape',
    ],
    summary: '手机端影音增强工具，实时调色、音频增强与字幕编辑一步到位。',
    description: '光影盒子是一款轻量的 Android 影音增强工具，可在播放的同时实时调整画面亮度、对比度与锐度，并对音频进行降噪与均衡增强。软件还内置字幕编辑与时间轴校正功能，适合对画质和听感有更高要求的用户。',
    features: [
      { title: '实时调色', desc: '播放中实时调节亮度、对比度、饱和度与锐度，画面随心所欲。' },
      { title: '音频增强', desc: '内置均衡器与人声增强，弱化嘈杂环境音，对白更清晰。' },
      { title: '字幕编辑', desc: '支持拖拽校正字幕时间轴与样式，外挂字幕轻松微调。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/lightbox-2.6.4.apk',
  },
  {
    id: 'yunque',
    name: '云雀播放器',
    enName: 'Skylark Player',
    categoryId: 'mac-player',
    platforms: ['Mac'],
    type: '播放器',
    version: 'v7.1.5',
    size: '44.8 MB',
    developer: '云雀工作室',
    releaseDate: '2018-09-14',
    updateDate: '2026-09-30',
    downloads: 4150000,
    rating: 4.9,
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20software%20cover%20art%20for%20a%20Mac%20video%20player%2C%20deep%20blue%20gradient%20with%20a%20refined%20bird%20emblem%20and%20soft%20amber%20light%20accents%2C%20premium%20minimal%20apple%20style%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-yunque&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Elegant%20macOS%20video%20player%20interface%20with%20a%20clean%20media%20library%20sidebar%20and%20movie%20thumbnail%20grid%2C%20light%20and%20dark%20refined%20UI%2C%20no%20text&width=1280&height=720&seq=shot-yunque-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mac%20video%20playback%20window%20with%20a%20slim%20translucent%20control%20bar%20and%20chapter%20markers%20timeline%2C%20cinematic%20dark%20UI%2C%20no%20text&width=1280&height=720&seq=shot-yunque-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=macOS%20preferences%20window%20of%20a%20video%20player%20with%20playback%20quality%20and%20hardware%20acceleration%20options%2C%20refined%20minimal%20UI%2C%20no%20text&width=1280&height=720&seq=shot-yunque-3&orientation=landscape',
    ],
    summary: 'macOS 上口碑极佳的原生播放器，界面精致，视频渲染细腻，色彩还原准确。',
    description: '云雀播放器是专为 macOS 打造的原生影视播放器，深度适配系统特性，支持触控板手势、画中画与原生全屏。软件在色彩管理与视频渲染上尤为出色，配合 Retina 屏幕能够呈现细腻准确的画面，是 Mac 用户观影的首选工具之一。',
    features: [
      { title: '原生体验', desc: '完美适配 macOS 手势、画中画与深色模式，操作如系统自带般自然。' },
      { title: '精准色彩', desc: '支持广色域与 HDR 映射，Retina 屏下画面细腻，色彩还原准确。' },
      { title: '格式通吃', desc: '内置解码内核，无需转码即可播放海量主流与冷门视频格式。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/skylark-7.1.5.dmg',
  },
  {
    id: 'xuebao',
    name: '雪豹影音',
    enName: 'SnowLeopard Player',
    categoryId: 'mac-player',
    platforms: ['Mac'],
    type: '播放器',
    version: 'v5.5.2',
    size: '37.6 MB',
    developer: '雪豹软件',
    releaseDate: '2019-12-02',
    updateDate: '2026-09-11',
    downloads: 3020000,
    rating: 4.6,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20software%20cover%20art%20for%20a%20Mac%20media%20player%2C%20cool%20deep%20blue%20background%20with%20a%20stylized%20snow%20leopard%20emblem%20and%20crystalline%20amber%20light%2C%20premium%20clean%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-xuebao&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=macOS%20media%20player%20home%20screen%20with%20recent%20videos%20carousel%20and%20playlist%20sidebar%2C%20sleek%20dark%20UI%20design%2C%20no%20text&width=1280&height=720&seq=shot-xuebao-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mac%20player%20playback%20view%20with%20subtitle%20style%20adjustment%20panel%20floating%20over%20video%2C%20dark%20refined%20interface%2C%20no%20text&width=1280&height=720&seq=shot-xuebao-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Mac%20video%20player%20screenshot%20capture%20and%20clip%20trim%20tool%20window%20with%20timeline%2C%20clean%20minimal%20UI%2C%20amber%20accent%20buttons%2C%20no%20text&width=1280&height=720&seq=shot-xuebao-3&orientation=landscape',
    ],
    summary: '轻快好用的 Mac 播放器，支持截图截取、字幕样式自定义与快捷键操作。',
    description: '雪豹影音是一款主打轻快体验的 macOS 视频播放器，界面简洁、响应迅速。软件提供灵活的截图与片段截取功能，方便用户保存精彩画面；同时支持字幕样式与位置的自定义，配合丰富的快捷键，让观影与分享都更高效。',
    features: [
      { title: '截图截取', desc: '一键截图或截取短视频片段，画质无损，分享精彩瞬间更方便。' },
      { title: '字幕自定义', desc: '自由调整字幕字体、大小、颜色与位置，打造专属观影样式。' },
      { title: '快捷操作', desc: '丰富快捷键覆盖播放、跳转、倍速等操作，无需鼠标也能流畅控制。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/snowleopard-5.5.2.dmg',
  },
  {
    id: 'hupo',
    name: '琥珀播放器',
    enName: 'Amber Player',
    categoryId: 'mac-player',
    platforms: ['Mac'],
    type: '解码器',
    version: 'v3.2.0',
    size: '26.1 MB',
    developer: '琥珀数码',
    releaseDate: '2020-10-16',
    updateDate: '2026-08-22',
    downloads: 1870000,
    rating: 4.4,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20software%20cover%20art%20for%20a%20codec%20tool%2C%20deep%20blue%20gradient%20with%20a%20glowing%20amber%20resin%20drop%20shape%20and%20subtle%20circuit%20patterns%2C%20premium%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-hupo&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Codec%20management%20panel%20on%20macOS%20listing%20video%20and%20audio%20codec%20modules%20with%20status%20badges%2C%20dark%20sleek%20UI%2C%20no%20text&width=1280&height=720&seq=shot-hupo-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Video%20format%20conversion%20tool%20window%20on%20Mac%20with%20input%20and%20output%20settings%20and%20progress%20bar%2C%20dark%20refined%20interface%2C%20no%20text&width=1280&height=720&seq=shot-hupo-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Hardware%20decoding%20performance%20monitor%20graph%20in%20a%20Mac%20codec%20application%2C%20dark%20UI%20with%20blue%20and%20amber%20charts%2C%20no%20text&width=1280&height=720&seq=shot-hupo-3&orientation=landscape',
    ],
    summary: '为 Mac 播放器补充解码能力的扩展工具，支持格式转换与硬件解码监测。',
    description: '琥珀播放器是一款面向 macOS 的解码扩展工具，能够为系统内各类播放器补充冷门格式的解码支持。软件提供视频格式转换、编码参数查看与硬件解码性能监测等功能，帮助用户排查播放卡顿、黑屏等常见问题。',
    features: [
      { title: '解码扩展', desc: '为系统播放器补齐冷门编码支持，告别格式不兼容的困扰。' },
      { title: '格式转换', desc: '支持主流音视频格式互转，兼容各类设备与剪辑软件。' },
      { title: '性能监测', desc: '实时监测硬件解码占用，快速定位播放卡顿的根本原因。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/amber-3.2.0.dmg',
  },
  {
    id: 'chenxi',
    name: '晨曦播放器',
    enName: 'Dawn Player',
    categoryId: 'ios-player',
    platforms: ['iOS'],
    type: '播放器',
    version: 'v4.3.8',
    size: '33.7 MB',
    developer: '晨曦科技',
    releaseDate: '2019-04-25',
    updateDate: '2026-09-25',
    downloads: 5680000,
    rating: 4.7,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20app%20cover%20art%20for%20an%20iPhone%20video%20player%2C%20deep%20blue%20sunrise%20gradient%20with%20warm%20amber%20glow%20and%20a%20minimal%20play%20symbol%2C%20premium%20ios%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-chenxi&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=iPhone%20video%20player%20app%20home%20screen%20with%20folder%20list%20and%20video%20thumbnails%2C%20dark%20elegant%20ios%20UI%2C%20blue%20and%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-chenxi-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=iPhone%20full%20screen%20video%20playback%20with%20gesture%20speed%20control%20indicator%20overlay%2C%20dark%20cinematic%20UI%2C%20no%20text&width=1280&height=720&seq=shot-chenxi-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=iOS%20video%20player%20playlist%20and%20playback%20history%20screen%20with%20clean%20cards%2C%20dark%20refined%20interface%2C%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-chenxi-3&orientation=landscape',
    ],
    summary: 'iPhone 上的高效播放器，支持 Wi-Fi 传片、手势调速与后台音频播放。',
    description: '晨曦播放器是一款功能全面的 iOS 视频播放器，支持通过 Wi-Fi 或 iTunes 快速传输影片到手机，省去数据线烦恼。软件提供手势调速、后台音频播放与画中画悬浮，配合简洁的操作逻辑，让 iPhone 也能成为随身影院。',
    features: [
      { title: 'Wi-Fi 传片', desc: '同一网络下用电脑浏览器即可上传影片，无需数据线。' },
      { title: '手势调速', desc: '播放中上下滑动微调播放速度，找到最舒适的观看节奏。' },
      { title: '后台播放', desc: '锁屏或切到后台仍可继续播放音频，通勤听剧两不误。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/dawn-4.3.8.ipa',
  },
  {
    id: 'yinghuo',
    name: '萤火看片',
    enName: 'Firefly Player',
    categoryId: 'ios-player',
    platforms: ['iOS'],
    type: '播放器',
    version: 'v3.7.1',
    size: '29.4 MB',
    developer: '萤火网络',
    releaseDate: '2020-08-08',
    updateDate: '2026-09-02',
    downloads: 3940000,
    rating: 4.5,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20app%20cover%20art%20for%20an%20iOS%20video%20player%2C%20deep%20blue%20night%20background%20with%20glowing%20amber%20firefly%20particles%20and%20a%20small%20play%20icon%2C%20premium%20elegant%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-yinghuo&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=iPad%20video%20player%20app%20interface%20with%20a%20split%20view%20of%20media%20library%20and%20preview%20panel%2C%20dark%20refined%20UI%2C%20no%20text&width=1280&height=720&seq=shot-yinghuo-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=iPad%20video%20playback%20with%20a%20floating%20control%20panel%20and%20chapter%20list%20sidebar%2C%20cinematic%20dark%20interface%2C%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-yinghuo-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=iOS%20app%20external%20subtitle%20import%20screen%20with%20file%20picker%20and%20encoding%20options%2C%20dark%20clean%20UI%2C%20no%20text&width=1280&height=720&seq=shot-yinghuo-3&orientation=landscape',
    ],
    summary: 'iPad 大屏观影好帮手，支持分屏浏览、外挂字幕与倍速追剧。',
    description: '萤火看片针对 iPad 大屏进行了深度优化，媒体库与播放界面充分利用宽屏空间，浏览与观影体验俱佳。软件支持外挂字幕导入、多音轨切换与 0.5 至 3 倍速无级调节，是追剧党与煲片党的得力助手。',
    features: [
      { title: '大屏优化', desc: '针对 iPad 宽屏布局，媒体库与播放控件排布更合理。' },
      { title: '外挂字幕', desc: '支持多种编码的外挂字幕导入，自动匹配时间轴。' },
      { title: '无级倍速', desc: '0.5 至 3 倍速自由调节，音调保持不变，追剧更高效。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/firefly-3.7.1.ipa',
  },
  {
    id: 'chaoxi',
    name: '潮汐看片',
    enName: 'Tide Player',
    categoryId: 'ios-player',
    platforms: ['iOS'],
    type: '辅助工具',
    version: 'v2.4.6',
    size: '18.9 MB',
    developer: '潮汐工作室',
    releaseDate: '2021-05-30',
    updateDate: '2026-08-14',
    downloads: 1520000,
    rating: 4.2,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20app%20cover%20art%20for%20an%20iOS%20media%20helper%2C%20deep%20blue%20ocean%20gradient%20with%20stylized%20tide%20waves%20and%20soft%20amber%20glow%2C%20minimal%20premium%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-chaoxi&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=iPhone%20app%20screen%20for%20managing%20video%20download%20tasks%20with%20progress%20rings%20and%20queue%20list%2C%20dark%20sleek%20UI%2C%20no%20text&width=1280&height=720&seq=shot-chaoxi-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=iOS%20app%20screen%20converting%20a%20video%20file%20format%20with%20before%20and%20after%20size%20comparison%2C%20dark%20clean%20interface%2C%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-chaoxi-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=iPhone%20app%20file%20cleanup%20and%20storage%20usage%20screen%20with%20colorful%20storage%20bars%2C%20dark%20modern%20UI%2C%20no%20text&width=1280&height=720&seq=shot-chaoxi-3&orientation=landscape',
    ],
    summary: 'iOS 端的下载与格式转换小助手，管理视频任务、清理存储空间。',
    description: '潮汐看片是一款轻量的 iOS 影音辅助工具，专注于视频任务管理与格式转换。软件可以集中管理下载队列、转换视频格式以适配不同设备，并提供存储空间分析与清理建议，帮助用户在容量有限的手机上腾出更多空间。',
    features: [
      { title: '任务管理', desc: '集中查看下载与转换进度，支持队列暂停与优先级调整。' },
      { title: '格式转换', desc: '在手机上直接转换视频格式与分辨率，适配各种播放设备。' },
      { title: '空间清理', desc: '分析视频占用的存储空间，一键清理冗余文件释放容量。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/tide-2.4.6.ipa',
  },
  {
    id: 'xingyun',
    name: '星云网页播放器',
    enName: 'Nebula Web Player',
    categoryId: 'web-player',
    platforms: ['Web', 'Windows', 'Mac'],
    type: '播放器',
    version: 'v2.9.3',
    size: '在线运行',
    developer: '星云云视',
    releaseDate: '2021-02-11',
    updateDate: '2026-09-19',
    downloads: 4210000,
    rating: 4.6,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20web%20app%20cover%20art%20for%20a%20browser%20video%20player%2C%20deep%20blue%20cosmic%20gradient%20with%20nebula%20clouds%20and%20glowing%20amber%20stars%2C%20premium%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-xingyun&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Web%20browser%20video%20player%20interface%20with%20a%20large%20video%20frame%20and%20playlist%20sidebar%2C%20dark%20elegant%20UI%2C%20blue%20and%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-xingyun-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Browser%20based%20full%20screen%20video%20playback%20with%20minimal%20floating%20controls%20and%20quality%20selector%2C%20dark%20cinematic%20web%20UI%2C%20no%20text&width=1280&height=720&seq=shot-xingyun-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Web%20player%20settings%20drawer%20with%20playback%20quality%20and%20subtitle%20language%20options%2C%20dark%20sleek%20browser%20interface%2C%20no%20text&width=1280&height=720&seq=shot-xingyun-3&orientation=landscape',
    ],
    summary: '免安装的浏览器播放方案，打开网页即可播放，跨系统即点即用。',
    description: '星云网页播放器是一款基于浏览器的在线播放方案，无需下载安装任何客户端，打开网页即可享受流畅的观影体验。软件采用先进的流媒体传输与自适应码率技术，在网络条件波动时也能保持画面稳定，适合临时观影或公共电脑场景。',
    features: [
      { title: '免安装', desc: '无需下载客户端，打开浏览器即可播放，随用随走不占空间。' },
      { title: '自适应码率', desc: '根据网络状况智能切换清晰度，弱网环境同样流畅。' },
      { title: '跨平台通用', desc: '兼容 Windows、Mac 与主流浏览器，一处内容处处可看。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/nebula-web-2.9.3.zip',
  },
  {
    id: 'guangnian',
    name: '光年在线影院',
    enName: 'Lightyear Online',
    categoryId: 'web-player',
    platforms: ['Web'],
    type: '播放器',
    version: 'v1.8.4',
    size: '在线运行',
    developer: '光年科技',
    releaseDate: '2022-03-05',
    updateDate: '2026-09-08',
    downloads: 2730000,
    rating: 4.3,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20web%20cinema%20cover%20art%2C%20deep%20blue%20space%20gradient%20with%20a%20distant%20light%20trail%20and%20floating%20movie%20posters%2C%20premium%20tech%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=800&height=500&seq=cover-guangnian&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Online%20cinema%20web%20homepage%20with%20a%20large%20featured%20banner%20and%20row%20based%20movie%20carousels%2C%20dark%20elegant%20UI%2C%20no%20text&width=1280&height=720&seq=shot-guangnian-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Web%20cinema%20video%20playback%20page%20with%20episode%20selector%20and%20related%20recommendations%20below%2C%20dark%20modern%20UI%2C%20amber%20accents%2C%20no%20text&width=1280&height=720&seq=shot-guangnian-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Online%20movie%20detail%20page%20in%20a%20browser%20with%20poster%20cast%20list%20and%20rating%2C%20dark%20clean%20web%20UI%2C%20no%20text&width=1280&height=720&seq=shot-guangnian-3&orientation=landscape',
    ],
    summary: '主打在线点播的网页影院，片库丰富、分类清晰，支持多端观看。',
    description: '光年在线影院是一款面向网页端设计的在线点播平台，拥有清晰的影片分类与智能的推荐算法。用户无需安装任何软件，通过浏览器即可浏览片库、查看影片详情并直接播放，同时支持观看历史同步，在手机与电脑之间无缝切换。',
    features: [
      { title: '在线点播', desc: '浏览器直接播放，片库分类清晰，找片迅速不迷路。' },
      { title: '智能推荐', desc: '根据观看偏好推荐相似影片，发现好片更轻松。' },
      { title: '多端同步', desc: '登录同一账号即可同步观看历史，多设备无缝衔接。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/lightyear-online-1.8.4.zip',
  },
  {
    id: 'lingxi',
    name: '灵犀解码库',
    enName: 'Lingxi Codec',
    categoryId: 'tools',
    platforms: ['Windows', 'Mac', 'Android'],
    type: '解码器',
    version: 'v6.0.2',
    size: '64.5 MB',
    developer: '灵犀开源社区',
    releaseDate: '2017-06-20',
    updateDate: '2026-09-26',
    downloads: 9120000,
    rating: 4.9,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20software%20cover%20art%20for%20a%20multimedia%20codec%20pack%2C%20deep%20blue%20background%20with%20glowing%20interconnected%20circuit%20nodes%20in%20amber%20and%20cyan%2C%20premium%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-lingxi&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Codec%20pack%20installer%20interface%20listing%20supported%20video%20and%20audio%20formats%20with%20checkboxes%2C%20dark%20sleek%20UI%2C%20no%20text&width=1280&height=720&seq=shot-lingxi-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=System%20integration%20status%20panel%20of%20a%20codec%20library%20showing%20registered%20applications%20and%20green%20indicators%2C%20dark%20UI%2C%20no%20text&width=1280&height=720&seq=shot-lingxi-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Technical%20format%20compatibility%20matrix%20table%20in%20a%20multimedia%20codec%20tool%2C%20dark%20modern%20interface%20with%20amber%20highlights%2C%20no%20text&width=1280&height=720&seq=shot-lingxi-3&orientation=landscape',
    ],
    summary: '覆盖全平台的开源解码库，一次安装让系统与播放器支持几乎所有格式。',
    description: '灵犀解码库是一款开源的多媒体解码合集，覆盖 Windows、Mac 与 Android 平台。安装后可为系统内置播放器及第三方软件补充海量音视频格式支持，无论是冷门的编码还是新出的封装格式，都能轻松解码，是影音玩家常备的基础工具。',
    features: [
      { title: '全平台覆盖', desc: '一套解码内核覆盖桌面与移动端，多设备统一体验。' },
      { title: '格式最全', desc: '包含数百种音视频编码与容器格式，冷门格式也能流畅播放。' },
      { title: '开源免费', desc: '完全开源、永久免费，无广告无捆绑，安装放心。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/lingxi-codec-6.0.2.exe',
  },
  {
    id: 'wanxiang',
    name: '万象音画引擎',
    enName: 'Vientiane Engine',
    categoryId: 'tools',
    platforms: ['Windows', 'Mac'],
    type: '辅助工具',
    version: 'v4.1.7',
    size: '58.2 MB',
    developer: '万象多媒体',
    releaseDate: '2019-01-15',
    updateDate: '2026-08-27',
    downloads: 4760000,
    rating: 4.7,
    cover: 'https://readdy.ai/api/search-image?query=Modern%20software%20cover%20art%20for%20an%20audio%20video%20processing%20engine%2C%20deep%20blue%20background%20with%20layered%20sound%20wave%20ribbons%20and%20amber%20light%20particles%2C%20premium%20tech%20aesthetic%2C%20no%20text&width=800&height=500&seq=cover-wanxiang&orientation=landscape',
    screenshots: [
      'https://readdy.ai/api/search-image?query=Audio%20and%20video%20transcoding%20queue%20dashboard%20with%20progress%20bars%20and%20format%20icons%2C%20dark%20modern%20UI%2C%20no%20text&width=1280&height=720&seq=shot-wanxiang-1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Advanced%20encoding%20settings%20window%20of%20a%20media%20engine%20with%20bitrate%20resolution%20and%20codec%20options%2C%20dark%20sleek%20interface%2C%20no%20text&width=1280&height=720&seq=shot-wanxiang-2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Audio%20waveform%20analysis%20view%20in%20a%20media%20processing%20tool%2C%20dark%20UI%20with%20blue%20and%20amber%20waveforms%2C%20no%20text&width=1280&height=720&seq=shot-wanxiang-3&orientation=landscape',
    ],
    summary: '专业级音画处理引擎，批量转码、压缩与画质增强一站完成。',
    description: '万象音画引擎是一款面向进阶用户的音视频处理工具，提供批量转码、视频压缩、画质增强与音频提取等功能。软件采用高效的编码内核，在保证画质的前提下大幅减小文件体积，适合需要整理、压缩或转码大量影视素材的用户。',
    features: [
      { title: '批量转码', desc: '支持批量导入与队列处理，海量素材一键转换省时省力。' },
      { title: '高效压缩', desc: '智能码率控制，在保持画质的同时显著减小文件体积。' },
      { title: '画质增强', desc: '内置降噪、锐化与超分算法，让老旧片源焕发新生。' },
    ],
    downloadUrl: 'https://911gg02.asia/software/vientiane-4.1.7.exe',
  },
];